import { 
    GET_LOGS,
    GET_LOGS_SUCCESS,
    GET_LOGS_FAIL, 
    GET_LOGS_RESET,
} from "../actions/getLogsAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const getLogsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_LOGS:
            return {
                ...state,
                apiState: "loading",
            };
        case GET_LOGS_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case GET_LOGS_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case GET_LOGS_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default getLogsReducer;
